import { Popper, styled, Theme } from "@mui/material";

export const StyledPopper = styled(Popper)(({ theme }) => ({
  border: "1px solid",
  borderColor: theme.palette.border.default,
  borderRadius: theme.radius.sm,
  width: 300,
  zIndex: theme.zIndex.modal,
  fontSize: theme.fontSizes.md,
  backgroundColor: theme.palette.background.paper,

  [theme.breakpoints.up("md")]: {
    width: 400,
  },

  "& .MuiAutocomplete-noOptions": {
    fontSize: theme.fontSizes.md,
  },
}));

export const minHeight = { minHeight: "100%" };

export const getStyles = (theme: Theme) => ({
  textField: {
    height: 36.5,
    mb: 0,

    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.border.default,
      textTransform: "none",

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.border.default,
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.border.default,
      },
    },
  },

  paper: {
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: theme.spacing(0.75),
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.surface.overlay,
      borderRadius: theme.radius.sm,
    },

    scrollbarWidth: "thin",
    scrollbarColor: `${theme.palette.transparent.medium} transparent`,

    "&:hover": {
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.transparent.heavy,
      },
      scrollbarColor: `${theme.palette.transparent.heavy} transparent`,
    },

    border: "none",
    boxShadow: "none",
  },

  groupHeaderStyle: {
    display: "flex",
    alignItems: "center",
    py: 0.5,
    fontWeight: theme.typography.fontWeightRegular as number,
    fontSize: theme.fontSizes.md,
    opacity: 0.6,
    pointerEvents: "none",
  },

  regionHeaderStyle: {
    display: "flex",
    alignItems: "center",
    py: 0.25,
    px: 0.5,
    fontWeight: theme.typography.fontWeightRegular as number,
    fontSize: theme.fontSizes.md,
    pointerEvents: "auto",
    ...minHeight,
  },

  icon: { fontSize: theme.fontSizes.lg },

  borderStyle: {
    position: "relative",
    paddingLeft: theme.spacing(1.5),

    "&::before": {
      content: '""',
      position: "absolute",
      left: theme.spacing(2.5),
      top: theme.spacing(4),
      bottom: 0,
      width: theme.spacing(0.25),
      opacity: 0.6,
      backgroundColor: theme.palette.text.secondary,
    },
  },

  groupName: { ml: theme.spacing(1) },
});

export const boxWidthSx = { width: { xs: "100%", md: 360 } };

export const getOptionStyle = (isClickable: boolean, theme: Theme) => ({
  pointerEvents: isClickable ? "auto" : "none",
  opacity: isClickable ? 1 : 0.6,
  display: "flex",
  alignItems: "center",
  fontWeight: theme.typography.fontWeightRegular as number,
  fontSize: theme.fontSizes.md,
  gap: theme.spacing(1),
  paddingLeft: theme.spacing(3),
  ...minHeight,
});
